import { Action } from '@ngrx/store';

export class StockIpoReservationAction implements Action {

    public static createIpoReservation = '[IPOs] create_reservation';
    public static ipoReservationError = '[IPOs] reservation_error';
    public static createIpoReservationSuccess = '[IPOs] create_reservation_success';
    public static finishIpoReservation = '[IPOs] finish_reservation';
    public static getIpoReservationsByCBLC = '[IPOs] get_ipo_reservation_by_cblc';
    public static getIpoReservationsByCBLCSuccess = '[IPOs] get_ipo_reservation_by_cblc_success';
    

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
